import PageWrapperMain from '../../components/page-wrappers/PageWrapperMain';
import SubPageContentHolder from '../../components/subPageContentHolder/SubPageContentHolder';
import ClientsList from './ClientsList';

const ClientsPage = () => {
  return (
    <PageWrapperMain>
      <div className='subPage'>
        <SubPageContentHolder>
          <ClientsList />
        </SubPageContentHolder>
      </div>
    </PageWrapperMain>
  );
};

export default ClientsPage;
